import { Button, IconName } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { ButtonFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';

interface Props extends TFormControlConnectorProps {
  control: ButtonFormControlViewModel;
}

const FormButtonControl = (props: Props): React.JSX.Element | null => {
  const { control, onRunSingleUpdater } = props;
  const {
    disabled,
    label,
    name,
    iconPosition,
    variant,
    icon,
    visible = true,
  } = control;

  return visible ? (
    <Button
      className={iconPosition === 'left' ? 'reverse' : undefined}
      label={label}
      disabled={disabled}
      name={name}
      icon={icon as IconName}
      variant={variant}
      onClick={() => onRunSingleUpdater(name)}
    />
  ) : null;
};

export default FormButtonControl;
